module.exports = __webpack_public_path__ + "static/media/lto-dill-mb-en.71039369.jpg";